export default __webpack_public_path__ + "static/media/Cow.24b65daf.svg";